import React from "react";

/**
 * Subtle shield + flame motif used as decorative backdrop accents.
 * Inspired by the AthenaCrest Defense logo.
 */
export default function ShieldMotif({ className = "", opacity = 0.06 }) {
  return (
    <svg
      viewBox="0 0 200 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      <path
        d="M100 8 L184 36 V120 C184 176 144 216 100 232 C56 216 16 176 16 120 V36 Z"
        stroke="#C5A059"
        strokeWidth="1.2"
        fill="none"
      />
      <path
        d="M100 36 L168 60 V120 C168 164 138 196 100 208 C62 196 32 164 32 120 V60 Z"
        stroke="#C5A059"
        strokeWidth="0.6"
        fill="none"
      />
      {/* flame */}
      <path
        d="M100 70 C108 86 118 96 118 116 C118 132 110 144 100 150 C90 144 82 132 82 116 C82 96 92 86 100 70 Z"
        stroke="#C5A059"
        strokeWidth="1"
        fill="none"
      />
      <path
        d="M100 90 C104 100 109 106 109 118 C109 126 105 132 100 136 C95 132 91 126 91 118 C91 106 96 100 100 90 Z"
        stroke="#104F55"
        strokeWidth="0.8"
        fill="none"
      />
    </svg>
  );
}
